import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import { Switch, Route, withRouter } from 'react-router-dom';
import 'moment/locale/pt';
import InsightcareFooter from './components/InsightcareFooter';
import AuxRoutines from './AuxRoutines';
//require('moment/locale/pt-BR');
import { BACKEND_URL } from './config/constants';

class PainelPS extends Component {

  constructor(props) {
    super(props);
    const { match: { params } } = this.props;
    console.log(params);
    this.state = {
      cycle: 0,
      totalCycles: 0,
      pacientes: [],
      numberOfElements: 0,
      base: params.base,
      company: params.company,
      locationName: AuxRoutines.getLocationName(params.base, params.company)
    };
    this.loadRequiredData = this.loadRequiredData.bind(this)
    setInterval(this.loadRequiredData, 20000);
    //setInterval(this.loadRequiredData, 5000);
    //this.randomize();
  }

  componentDidMount() {

    //Carrega o local se existe
    this.loadRequiredData().then(() => {
      this.setState({ appIsReady: true });
    });
  }


  async loadRequiredData() {
    let sliceSize = 35;

    moment.locale('pt');
    if (this.state.cycle === this.state.totalCycles) {
      let currentDateHour = moment().format('HH:mm | D [de] MMMM [de] YYYY');
      let pacientes = await this.requestData();
      let numberOfElements = pacientes.length;
      let cycle = 1;
      let totalCycles = Math.ceil(numberOfElements / sliceSize);
      if (totalCycles == 0) {
        cycle = 0;
      }
      this.setState(
        {
          currentDateHour: currentDateHour,
          dashboardData: pacientes,
          pacientes: pacientes.slice(0, sliceSize),
          numberOfElements: numberOfElements,
          cycle: cycle,
          totalCycles: totalCycles
        }
      );
    } else {
      if (this.state.totalCycles > 0) {
        this.setState({ cycle: this.state.cycle + 1, pacientes: this.state.dashboardData.slice(0 + (sliceSize * this.state.cycle), sliceSize + (sliceSize * this.state.cycle)) })
      }
    }

  }

  async requestData() {
    let returnData = this.state.pacientes; //In case request fails
    //console.log(this.state.base)
    //let url = 'http://localhost:8080/command-center/painel-urgencia?base='+this.state.base;
    let url = BACKEND_URL + '/command-center/painel-urgencia?base=' + this.state.base;
    if (this.state.company !== undefined && this.state.company !== null) {
      url = url + '&company=' + this.state.company;
    }
    let response = await axios.get(url);

    //console.log(response.data);
    if (response.data && response.data.Status === true) {
      returnData = response.data.ResponseData;
    }
    return returnData;
  }

  render() {
    let render = 0
    if (this.state.base === 'db-orcl-hsl' && this.state.company === '3') {
      render = 1
    }
    if (render == 0) {
      return (
        <div className="App">
          <header>
            <h1 id="title">Painel de Acompanhamento - {this.state.numberOfElements} pacientes ({this.state.cycle}/{this.state.totalCycles})</h1>
            <img src="/img/logo.png" alt="InsightCare" />
          </header>

          <main className="content" id="panel1">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th width="1%"></th>
                  <th width="15%">
                    <img src="/img/icon_status.svg" alt="" />Status
                  </th>
                  <th width="20%">
                    <img src="/img/icon_patient.svg" alt="" />Paciente
                  </th>
                  <th width="23%">
                    <img src="/img/icon_laboratory.svg" alt="" />Laboratório
                  </th>
                  <th width="23%">
                    <img src="/img/icon_radiology.svg" alt="" />Radiologia
                  </th>
                  <th width="23%">
                    <img src="/img/icon_medicine.svg" alt="" />Medicação
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.state.pacientes.map((data) => {
                  let status = "-";
                  let statusClass = "ready";
                  let statusLab = "-";
                  let statusRx = "-";
                  let statusFarm = "-";
                  let totalLab = parseInt(parseInt(data.LAB_PENDENTE) + parseInt(data.LAB_LAUDADO));
                  let totalRx = parseInt(parseInt(data.RX_PENDENTE) + parseInt(data.RX_LAUDADO));
                  let totalFarm = parseInt(parseInt(data.FARM_PENDENTE) + parseInt(data.FARM_SEPARADO));
                  let atendimento = data.ATENDIMENTO;
                  let tdClassLab = "";
                  let spanClassLab = "";
                  let tdClassRx = "";
                  let spanClassRx = "";
                  let tdClassFarm = "";
                  let spanClassFarm = "";
                  let name = data.PACIENTE_NOME.trim().split(/[\s,\t,\n]+/).join(' ');
                  name = name.split(' ').slice(-1).join(' ') + ', ' + name.split(' ')[0].slice(0, 1);
                  // let name = data.PACIENTE_NOME.split(' ')[0] + ' ' + data.PACIENTE_NOME.split(' ').slice(-1).join(' ');

                  if (data.LAB_LAUDADO > 0) {
                    statusLab = data.LAB_LAUDADO + " de " + totalLab + " laudo(s) disponíveis";
                    tdClassLab = "attention";
                    spanClassLab = "success-circle";
                    if (totalLab > data.LAB_LAUDADO) spanClassLab = "warning-circle";
                  } else {
                    if (data.LAB_PENDENTE > 0) {
                      statusLab = "Aguardando " + data.LAB_PENDENTE + " Laudo(s)";
                      tdClassLab = "attention";
                      spanClassLab = "attention-circle";
                    }
                  }

                  if (data.RX_LAUDADO > 0) {
                    statusRx = data.RX_LAUDADO + " de " + totalRx + " laudo(s) disponíveis";
                    tdClassRx = "attention";
                    spanClassRx = "success-circle";
                    if (totalRx > data.RX_LAUDADO) spanClassRx = "warning-circle";
                  } else {
                    if (data.RX_PENDENTE > 0) {
                      statusRx = "Aguardando " + data.RX_PENDENTE + " Laudo(s)";
                      tdClassRx = "attention";
                      spanClassRx = "attention-circle";
                    }
                  }

                  if (data.FARM_SEPARADO > 0) {
                    statusFarm = data.FARM_SEPARADO + " de " + totalFarm + " itens prontos";
                    tdClassFarm = "attention";
                    spanClassFarm = "success-circle";
                    if (totalFarm > data.FARM_SEPARADO) spanClassFarm = "warning-circle";
                  } else {
                    if (data.FARM_PENDENTE > 0) {
                      statusFarm = "Aguardando preparo de " + data.FARM_PENDENTE + " itens";
                      tdClassFarm = "attention";
                      spanClassFarm = "attention-circle";
                    }
                  }

                  if (data.FARM_SEPARADO > 0) {
                    status = "Medicação pronta";
                    statusClass = "ready";
                  } else {
                    if (data.FARM_PENDENTE > 0) {
                      status = "Aguardando preparo";
                      statusClass = "waiting";
                    }
                  }

                  if (data.RX_LAUDADO > 0 || data.LAB_LAUDADO > 0) {
                    status = "Laudos disponíveis";
                    statusClass = "ready";
                  } else {
                    if (data.RX_PENDENTE > 0 || data.LAB_PENDENTE > 0) {
                      status = "Aguardando laudos";
                      statusClass = "waiting";
                    }
                  }

                  return (
                    <tr key={this.state.Paciente} className={statusClass}>
                      <td><div className="alert-label"></div></td>
                      <td>{status}</td>
                      <td><b>{name}</b> ({atendimento})</td>
                      <td className={tdClassLab}><span className={spanClassLab}></span>{statusLab}</td>
                      <td className={tdClassRx}><span className={spanClassRx}></span>{statusRx}</td>
                      <td className={tdClassFarm}><span className={spanClassFarm}></span>{statusFarm}</td>
                    </tr>
                  )
                })
                }

              </tbody>
            </table>
          </main>


          <InsightcareFooter dateHour={this.state.currentDateHour} hospitalName={this.state.locationName} />
        </div>
      );
    }
    if (render == 1) {
      return (
        <div className="App">
          <header>
            <h1 id="title">Painel de Acompanhamento - {this.state.numberOfElements} pacientes ({this.state.cycle}/{this.state.totalCycles})</h1>
            <img src="/img/logo.png" alt="InsightCare" />
          </header>

          <main className="content" id="panel1">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th width="1%"></th>

                  <th width="33%" style={{ textAlign: 'center' }} >
                    <img src="/img/icon_patient.svg" alt="" />Paciente
                  </th>
                  <th width="33%" style={{ textAlign: 'center' }}>
                    <img src="/img/icon_laboratory.svg" alt="" />Laboratório
                  </th>
                  <th width="33%" style={{ textAlign: 'center' }}>
                    <img src="/img/icon_radiology.svg" alt="" />Radiologia
                  </th>

                </tr>
              </thead>
              <tbody>
                {this.state.pacientes.map((data) => {
                  let status = "-";
                  let statusClass = "ready";
                  let statusLab = "-";
                  let statusRx = "-";
                  let statusFarm = "-";
                  let totalLab = parseInt(parseInt(data.LAB_PENDENTE) + parseInt(data.LAB_LAUDADO));
                  let totalRx = parseInt(parseInt(data.RX_PENDENTE) + parseInt(data.RX_LAUDADO));
                  let totalFarm = parseInt(parseInt(data.FARM_PENDENTE) + parseInt(data.FARM_SEPARADO));
                  let atendimento = data.ATENDIMENTO;
                  let tdClassLab = "";
                  let spanClassLab = "";
                  let tdClassRx = "";
                  let spanClassRx = "";
                  let tdClassFarm = "";
                  let spanClassFarm = "";
                  let name = data.PACIENTE_NOME.trim().split(/[\s,\t,\n]+/).join(' ');
                  name = name.split(' ').slice(-1).join(' ') + ', ' + name.split(' ')[0].slice(0, 1);
                  //let name = data.PACIENTE_NOME.split(' ')[0] + ' ' + data.PACIENTE_NOME.split(' ').slice(-1).join(' ');

                  if (data.LAB_LAUDADO > 0) {
                    statusLab = data.LAB_LAUDADO + " de " + totalLab + " laudo(s) disponíveis";
                    //tdClassLab="attention";
                    tdClassLab = "alert alert-success";
                    spanClassLab = "success-circle";
                    if (totalLab > data.LAB_LAUDADO) tdClassLab = "alert alert-warning";
                  } else {
                    if (data.LAB_PENDENTE > 0) {
                      statusLab = "Aguardando " + data.LAB_PENDENTE + " Laudo(s)";
                      //tdClassLab="attention";
                      tdClassLab = "alert alert-danger";
                      spanClassLab = "attention-circle";
                    }
                  }

                  if (data.RX_LAUDADO > 0) {
                    statusRx = data.RX_LAUDADO + " de " + totalRx + " laudo(s) disponíveis";
                    //tdClassRx="attention";
                    tdClassRx = "alert alert-success";
                    spanClassRx = "success-circle";
                    if (totalRx > data.RX_LAUDADO) {
                      tdClassRx = "alert alert-warning";
                      spanClassRx = "warning-circle";
                    }
                  } else {
                    if (data.RX_PENDENTE > 0) {
                      statusRx = "Aguardando " + data.RX_PENDENTE + " Laudo(s)";
                      tdClassRx = "attention";
                      tdClassRx = "alert alert-danger";
                      spanClassRx = "attention-circle";
                    }
                  }

                  if (data.FARM_SEPARADO > 0) {
                    statusFarm = data.FARM_SEPARADO + " de " + totalFarm + " itens prontos";
                    tdClassFarm = "attention";
                    spanClassFarm = "success-circle";
                  } else {
                    if (data.FARM_PENDENTE > 0) {
                      statusFarm = "Aguardando preparo de " + data.FARM_PENDENTE + " itens";
                      tdClassFarm = "attention";
                      spanClassFarm = "attention-circle";
                    }
                  }

                  if (data.FARM_SEPARADO > 0) {
                    status = "Medicação pronta";
                    statusClass = "ready";
                  } else {
                    if (data.FARM_PENDENTE > 0) {
                      status = "Aguardando preparo";
                      statusClass = "waiting";
                    }
                  }

                  if (data.RX_LAUDADO > 0 || data.LAB_LAUDADO > 0) {
                    status = "Laudos disponíveis";
                    statusClass = "ready";
                  } else {
                    if (data.RX_PENDENTE > 0 || data.LAB_PENDENTE > 0) {
                      status = "Aguardando laudos";
                      statusClass = "waiting";
                    }
                  }

                  return (
                    <tr key={this.state.Paciente} className={statusClass}>
                      <td><div className="alert-label"></div></td>
                      <td><b>{name} ({atendimento})</b></td>
                      <td className={tdClassLab}>{statusLab}</td>
                      <td className={tdClassRx}>{statusRx}</td>
                    </tr>
                  )
                })
                }

              </tbody>
            </table>
          </main>


          <InsightcareFooter dateHour={this.state.currentDateHour} hospitalName={this.state.locationName} />
        </div>
      );
    }
  }

}

export default PainelPS;
